import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('setting-approval/index', {params});
    },
    show(id) {
        return Service().get('setting-approval/show/'+id);
    },
    create(params) {
        return Service().post('setting-approval/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('setting-approval/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('setting-approval/delete/'+id);
    },
    import(params) {
        return Service().post('import/setting-approval', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
}